import './styles.styl'
import 'react-toggle/style.css'

import React from 'react'
import Toggle from 'react-toggle'
import {
  MODULES
} from '../../../settings'

export default class SettingsWebshop extends React.Component {
  constructor (props) {
    super(props)

    let state = {
      showVAT: (props.storeType !== 'IBRANDSTORE'),
      showShipping: true,
      isOrganisationShop: false,
      modules: props.storeType === 'S-STORE' ? ['Accordatie orders'] : [],
      findUserMinimumLevel: 60,
      outOfStockDefaultMessage: 'Op voorraad',
      outOfStockLocalisation: 'stock.no-stock'
    }

    if (props.data !== null) {
      state = {
        ...state,
        ...props.data
      }
    }

    if (props.storeType === 'S-STORE' && !state.modules.includes('Accordatie orders')) {
      state.modules = [
        ...state.modules,
        'Accordatie orders'
      ]
    }

    this.state = state
  }

  componentWillReceiveProps (props) {
    if (props.data !== null) {
      const newState = {
        ...this.state,
        ...props.data
      }

      if (typeof props.data.isOrganisationShop !== 'boolean') {
        newState.isOrganisationShop = false
      }

      if (props.storeType === 'S-STORE' && !newState.modules.includes('Accordatie orders')) {
        newState.modules = [
          ...newState.modules,
          'Accordatie orders'
        ]
      }
      
      this.setState(newState)
    }

    if (props.data === null && props.basicSettings !== null) {
      this.setState({ showVAT: (props.storeType !== 'IBRANDSTORE') })
    }
  }

  saveAndToggle (index) {
    this.props.save({ ...this.state })
    this.props.toggleSection(index)
  }

  saveAndNext (index) {
    this.props.save({ ...this.state })
    this.props.nextSection(index)
  }

  render () {
    const index = this.props.index
    const moduleToggles = MODULES.map((moduleName, i) => {
      return <div key={i} className='toggle-switch'>
        <Toggle
          checked={this.state.modules.includes(moduleName)}
          disabled={moduleName === 'Accordatie orders' && this.props.storeType === 'S-STORE'}
          onChange={e => {
            const state = { ...this.state }

            if (e.target.checked === false && state.modules.indexOf(moduleName) !== -1) {
              state.modules.splice(state.modules.indexOf(moduleName), 1)
            }

            if (e.target.checked === true && state.modules.indexOf(moduleName) === -1) {
              state.modules.push(moduleName)
            }

            this.setState({ modules: state.modules })
          }}
        />
        <span>{moduleName}</span>
      </div>
    })

    let content = (
      <div className='row section-content'>
        <div className='col-12 col-lg-10'>
          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Voorraad</label>
            </div>

            <div className='col-12 col-sm-8' style={{ paddingBottom: '2em' }}>
              <label className='form-label'>Standaard tekst bij geen voorraad</label>
              <input
                type='text'
                className='form-control'
                value={this.state.outOfStockDefaultMessage}
                onChange={e => this.setState({ outOfStockDefaultMessage: e.target.value })}
                placeholder='E.g. "geen voorraad"'
              />

              <label className='form-label'>Localisatie-key geen voorraad</label>
              <input
                type='text'
                className='form-control'
                value={this.state.outOfStockLocalisation}
                onChange={e => this.setState({ outOfStockLocalisation: e.target.value })}
                placeholder='E.g. "stock.out-of-stock"'
              />
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>BTW</label>
            </div>

            <div className='col-12 col-sm-8'>
              <div className='toggle-switch'>
                <Toggle
                  checked={this.state.showVAT}
                  onChange={e => this.setState({ showVAT: e.target.checked })}
                />
                <span>BTW weergeven (producten &amp; checkout)</span>
              </div>
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Verzendkosten</label>
            </div>

            <div className='col-12 col-sm-8'>
              <div className='toggle-switch'>
                <Toggle
                  checked={this.state.showShipping}
                  onChange={e => this.setState({ showShipping: e.target.checked })}
                />
                <span>Verzendkosten weergeven (checkout)</span>
              </div>
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Organisatie/persoonlijk</label>
            </div>

            <div className='col-12 col-sm-8'>
              <div className='toggle-switch'>
                <Toggle
                  checked={this.state.isOrganisationShop === true}
                  onChange={e => this.setState({ isOrganisationShop: (e.target.checked === true) })}
                />
                <span>Gebruikers bestellen als organisatie</span>
              </div>

              <div className='toggle-switch'>
                <Toggle
                  checked={this.state.isOrganisationShop === false}
                  onChange={e => this.setState({ isOrganisationShop: !(e.target.checked === true) })}
                />
                <span>Gebruikers bestellen als natuurlijk persoon</span>
              </div>
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Modules webshop</label>
            </div>

            <div className='col-12 col-sm-8'>
              {moduleToggles}
            </div>
          </div>

          {this.state.modules.includes('Gebruiker zoeken op klantnummer') && (
            <div className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>Gebruiker zoeken</label>
              </div>

              <div className='col-12 col-sm-8'>
                <div className='form-group'>
                  <label className='form-label'>Minimaal niveau</label>
                  <input
                    type='text'
                    className='form-control'
                    value={this.state.findUserMinimumLevel}
                    onChange={e => this.setState({ findUserMinimumLevel: e.target.value })}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )

    if (this.props.storeType === 'NONE') {
      content = (
        <div className='row section-content'>
          <div className='col-12 col-lg-10'>
            <p><em>Stel s.v.p. éérst het type project in bij de basisinstellingen.</em></p>
          </div>
        </div>
      )
    }

    if (this.props.storeType === 'API') {
      content = (
        <div className='row section-content'>
          <div className='col-12 col-lg-10'>
            <p><em>Er zijn geen webshop instellingen voor API projecten.</em></p>
          </div>
        </div>
      )
    }

    return (
      <section key={index} className={['section', (this.props.open ? 'section-open' : 'section-closed')].join(' ')}>
        <div className='row section-title'>
          <div className='col-10'>
            <h3>Webshop</h3>
          </div>

          <div className='col-2 text-align-right'>
            <a href='#' onClick={() => this.saveAndToggle(index)} className='edit-link'>{this.props.open ? 'Sluiten' : 'Bewerken'}</a>
          </div>
        </div>
        {content}
        <div className='row section-buttons'>
          <div className='col-12 text-align-right'>
            <button className='btn btn-sm btn-secondary btn-rounded' onClick={() => this.saveAndNext(index)}>Volgende &raquo;</button>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/projects/create/settings-webshop.js